<template>
<div class="log-table">
    <b-table
        :items="inputValue"
        :fields="inputFields"
        small
        thead-class="font-weight-bold"
        table-class="mb-1"
        :thead-class="theadClass"
        >
        <template v-slot:cell(action)="data">
            <b-link
                class="text-secondary"
                href="#"
                @click="deleteLog($event, data.index)"
                tabindex="-1"
                >
                <font-awesome-icon icon="trash-alt" class="fa-fw" />
            </b-link>
            <b-link
                class="text-secondary"
                href="#"
                @click="copyLog($event, data.index)"
                tabindex="-1"
                v-if="showBtnRowCopy"
                >
                <font-awesome-icon icon="copy" class="fa-fw" />
            </b-link>
        </template>
        <template
            v-for="(slotContent, slotName) of $scopedSlots"
            #[slotName]="data"
            >
            <slot :name="slotName" v-bind="data"></slot>
        </template>
        <template v-slot:cell(action2)="data" v-if="showBtnRowMove">
            <b-link
                class="text-secondary"
                href="#"
                @click="moveUp($event, data.index)"
                tabindex="-1"
                >
                <font-awesome-icon icon="chevron-circle-up" class="fa-fw" />
            </b-link>
            <br>
            <b-link
                class="text-secondary"
                href="#"
                @click="moveDown($event, data.index)"
                tabindex="-1"
                >
                <font-awesome-icon icon="chevron-circle-down" class="fa-fw" />
            </b-link>
        </template>
        <template v-slot:table-colgroup>
            <slot name="table-colgroup"></slot>
        </template>
    </b-table>
    <div>
        <b-link
            href="#"
            @click="pushLog($event)"
            >
            <slot name="addRowButton">追加</slot>
        </b-link>
    </div>
</div>
</template>

<script>
export default {
    components: {},
    props: {
        value: {
            type: Array,
            required: false,
            default() {
                return []
            },
        },
        fields: {
            type: Array,
            required: true,
            default() {
                return []
            },
        },
        defaultRow: {
            type: Object,
            required: false,
            default() {
                return {}
            },
        },
        showBtnRowMove: {
            type: Boolean,
            required: false,
            default() {
                return true
            },
        },
        showBtnRowCopy: {
            type: Boolean,
            required: false,
            default() {
                return true
            },
        },
        autoAddRow: {
            type: Boolean,
            required: false,
            default() {
                return false
            },
        },
        theadClass: {
            type: [ Array, Object, String, ],
            required: false,
            default() {
                return null
            },
        },
    },
    data() {
        return {}
    },
    computed: {
        inputValue: {
            get() {
                if (!this.value) {
                    return []
                }
                const a = this.$utils.extend(this.value)
//                const a = this.$utils.copy(this.value)
                for (let i = 0; i < a.length; i++) {
                    // 空の配列は空のオブジェクトに変換
                    if (Array.isArray(a[i]) && a[i].length === 0) {
                        a.splice(i, 1, {})
                    }
                    for (let j = 0; j < this.fields.length; j++) {
                        if (a[i][this.fields[j].key] === undefined) {
                            this.$set(a[i], this.fields[j].key,  null)
                        }
                    }
                }
                return a
            },
            set(value) {
                this.$emit('input', value)
            },
        },
        inputFields: {
            get() {
                const f = this.$utils.copy(this.fields)
                f.unshift({ key: 'action', label: '', thStyle: { width: '4.5em', }, /*tdClass: 'align-middle',*/ })
                if (this.showBtnRowMove) {
                    f.push({ key: 'action2', label: '' })
                }
                return f
            },
        },
    },
    mounted() {
        if (!Array.isArray(this.inputValue) || this.inputValue.length === 0) {
            this.pushLog()
        }
    },
    destroyed() {},
    methods: {
        pushLog($event) {
            if (!this.inputValue) {
                this.inputValue = []
            }
            this.inputValue.push(this.$utils.copy(this.defaultRow))
        },
        deleteLog($event, index) {
            if (!this.inputValue) {
                this.inputValue = []
                return
            }
            this.inputValue.splice(index, 1)
        },
        copyLog($event, index) {
            if (!this.inputValue) {
                this.inputValue = []
                return
            }
            this.inputValue.splice(index + 1, 0, this.$utils.copy(this.inputValue[index]))
        },
        moveUp($event, index) {
            if (index === 0) {
                return
            }
            const current = JSON.parse(JSON.stringify(this.inputValue[index]))
            const target = JSON.parse(JSON.stringify(this.inputValue[index - 1]))
            this.inputValue.splice(index - 1, 1, current)
            this.inputValue.splice(index, 1, target)
        },
        moveDown($event, index) {
            if (index >= this.inputValue.length - 1) {
                return
            }
            const current = JSON.parse(JSON.stringify(this.inputValue[index]))
            const target = JSON.parse(JSON.stringify(this.inputValue[index + 1]))
            this.inputValue.splice(index + 1, 1, current)
            this.inputValue.splice(index, 1, target)
        },
        keybindingForLogTable($event, index) {
            if ($event.isComposing) {
                return
            }

            let pattern = 
                'input:not(:disabled):not([readonly]):not([type=hidden])' +
                ',select:not(:disabled):not([readonly])' +
                ',textarea:not(:disabled):not([readonly])'

            let inputs = Array.from(
                document
                    .activeElement
                    .closest('.log-table')
                    .querySelectorAll(pattern)
            )
            let input_row_count = Array.from(
                document
                    .activeElement
                    .closest('tr')
                    .querySelectorAll(pattern)
            ).length
            let index_now = inputs.findIndex(node => node === document.activeElement)
            let is_binded = true

            switch ($event.key) {
                case 'Enter':
                case '____ArrowRight':
                    if (index_now < inputs.length - 1) {
                        inputs[index_now + 1].focus()
                    } else {
                        if (this.autoAddRow) {
                            this.pushLog()
                            this.$nextTick(() => {
                                this.keybindingForLogTable($event)
                            })
                        }
                    }
                    break;
                case '____ArrowLeft':
                    if (index_now > 0) {
                        inputs[index_now - 1].focus()
                    }
                    break;
                case '____ArrowDown':
                    if (index_now < inputs.length - input_row_count) {
                        inputs[index_now + input_row_count].focus()
                    } else {
                        if (this.autoAddRow) {
                            this.pushLog()
                            this.$nextTick(() => {
                                this.keybindingForLogTable($event)
                            })
                        }
                    }
                    break;
                case '____ArrowUp':
                    if (index_now > input_row_count - 1) {
                        inputs[index_now - input_row_count].focus()
                    }
                    break;
                default:
                    is_binded = false
                    break;
            }

            if (is_binded) {
                document.activeElement.select()
                $event.preventDefault()
            }
        },
    },
}
</script>

<style lang="scss" scoped></style>

